var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Spinner = require("components/utility/Spinner");
var ReactionFeedback = require("components/support/ReactionFeedback");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");

require("writing/answers/answer_analysis_display.scss");

var CurrentUser = require("lib/account/CurrentUser");

class AnswerAnalysisDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		if (props.shouldCollapse) {
			var show = false
		} else {
			var show = true
		}
		this.state = {
			leaves: null,
			show: show
		};
	}
	triggerShow() {
		if (!this.state.show) {
			if (!this.state.analysis) {
				this.loadAnalysis();
				this.setState({show: !this.state.show});
			} else{
				this.setState({show: !this.state.show},this.triggerChainDisplay.bind(this,">"))
			}
			
		} else {
			this.setState({show: !this.state.show})
		}
	}

	renderReactionFeedback() {
		var reactionDetails = {}
		reactionDetails[ReactionFeedback.HAPPY] = { label: "Great!" };
		reactionDetails[ReactionFeedback.NEUTRAL] = { label: "Not quite..." };
		reactionDetails[ReactionFeedback.SAD] = { label: "Completely wrong!" };
		
		var subjectType = "answer"
		var subjectID = this.props.answerID
	
		var reactionWhere = "component-post-quiz-feedback-" + subjectType 

		return <ReactionFeedback where={ reactionWhere }
			key={ reactionWhere } 
			textOnly={ false }
			options={ reactionDetails }
			title={ "Was this helpful?" }
			placeholder={"Help us improve our scoring by telling us why..."}
			component_position = { ReactionFeedback.POSITION_BOTTOM_RIGHT }
			popover_position={ ReactionFeedback.POSITION_BOTTOM_RIGHT }
			subjectType={subjectType}
			subjectID={ subjectID } />
	}

	renderCategory(catKey, index) {
		var dynamicDisplayClass = ">" + index;

		var index = 0;
		var elements = _.map(ANALYSIS_CONFIG[catKey], (leafKeys, label) => {
			index += 1;
			return this.renderElement(dynamicDisplayClass, label, leafKeys, index);
		})

		return (
			<div key={ catKey } key={ catKey } className="categoryRow">
				<b className="hiddenElement" ref={ dynamicDisplayClass + "_0" }>{ catKey }</b>
				<table className="feedbackTable" ref={ catKey + "_table" }>
					<tbody>
						{ elements }
					</tbody>
				</table>
			</div>
		)
	}

	renderElement(cat, label, leafKeys, index) {
		var leaves = _.values(_.pick(this.state.leaves, leafKeys));
		var leafValue = _.reduce(leaves, (sum, leaf) => { return sum + leaf.value }, 0) / leaves.length;

		var asScore = AutograderDisplayConfig.leafValueToScore(leafValue);
		var dynamicDisplayClass = cat + "_" + index
		return (
			<tr className="feebackTableRow hiddenElement" ref={ dynamicDisplayClass + "_0" } key={ label } >
				<td className="descriptionCell">
					{ this.renderLabel(label, asScore)}
				</td>
				{ this.renderValidCount(asScore, dynamicDisplayClass) }
			</tr>
		);
	}

	renderValidCount(asScore, dynamicDisplayClass) {

		if (asScore == 4) {
			var cssClass = "valid"
			var glyphi = <Glyphicon icon={ "glyphicon glyphicon-ok-sign" } />
		} else if (asScore == 3) {
			var cssClass = "average"
			var glyphi = <Glyphicon icon={ "glyphicon glyphicon-exclamation-sign" } />
		} else {
			var cssClass = "error"
			var glyphi = <Glyphicon icon={ "glyphicon glyphicon-exclamation-sign" } />
		}
		return (
			<td className="validCountCell">
				<div className={ "icon hiddenElement " + cssClass } ref={ dynamicDisplayClass + "_1" }>
					{ glyphi }
				</div>
			</td>
		)
	}
	renderLabel(label, asScore) {
		if (asScore == 4) {
			var textIndex = 0 
		} else if (asScore == 3) {
			var textIndex = 1 
		} else {
			var textIndex = ANALYSIS_LABEL[label].length - 1
		}
		return (<div className="description">{ ANALYSIS_LABEL[label][textIndex] }</div>)
	}

	render() {
		if (this.props.shouldCollapse) {
			if (this.state.show) {
				var optionText = "Hide results"
			} else {
				var optionText = "Show results"
			}
			var collapseOption = <a className="collapseOption hideOnPrint" onClick={this.triggerShow}>{ optionText }</a>
		}
		if (this.state.show) {
			if (this.state.leaves) {
				var feedback = _.keys(ANALYSIS_CONFIG).map(this.renderCategory.bind(this))
				var content = (
					<div className="feedbackArea">
						{ feedback }
						<div className="hiddenElement" ref=">_999">
							{ this.renderReactionFeedback() }
						</div>
					</div>
				)
			} else {
				var content = <Spinner placeholder={ true }/>
			}
		}
		return (
			<div className="answerAnalysisDisplay">
				{ collapseOption }
				{ content }
			</div>
		)
	}
	triggerChainDisplay(dynamicDisplayClass) {
		var refs = Object.keys(this.refs).filter(function(key){if(key.includes(dynamicDisplayClass)){return 1} else {return 0}})
		if (refs.length > 0) {
			var index = 0;
			refs.sort();
			function showNext() {
				index += 1
				if (index < refs.length) {
					$( this.refs[refs[index]]).show( this.props.delay, showNext.bind(this) );
				} else {
					if (this.props.showCoinTable) {
						this.props.showCoinTable()
					}
				}
			}
			$(this.refs[refs[index]]).show( this.props.delay,showNext.bind(this) );
		}
	}

	loadAnalysis() {
		CurrentUser.api().getAnswer(this.props.answerID, { "embed":"answer.evaluation_details" },
			$wr.apiHandler(function(response) {

			if (response.answer && response.answer.evaluation_details && response.answer.evaluation_details.polarizing) {
				this.setState({
					leaves: response.answer.evaluation_details.polarizing
				}, this.triggerChainDisplay.bind(this, ">"));
			}
		}.bind(this)))
	}
	
	componentDidMount() {
		if (!this.props.shouldCollapse) {
			this.loadAnalysis()
		}
	}
}

var ANALYSIS_CONFIG = {
	"Spelling and Grammar": {
		"Capitalization issues": ["comm-conv-mech-caps"],
		"Ending punctuation is present": ["comm-conv-mech-punc"],
		"Correct grammar and spelling": ["comm-conv-mech-gram", "comm-conv-mech-spell"]
	}, 
	"Organization and Vocabulary": {
		"Good usage of punctuation": ["comm-conv-org-sent-struct"],
		"Good introduction": ["comm-conv-org-intro"],
		"Avoiding overused words": ["comm-conv-voc-overused-vary"],
		"Advanced word choice": ["comm-conv-voc-level-complex", "comm-conv-voc-level-metrics"]
	},
	"Comprehension": {
		"Including details from the text": ["crit-evi-form-detail"],
		"Fully answering the question": ["crit-rc-atq-restated"]
	}
}

var ANALYSIS_LABEL = {
	"Capitalization issues": ["Good use of capitalization","Some capitalization issues","Capitalization issues"],
	"Ending punctuation is present": ["Ending punctuation is present","Some punctuation marks are present","Missing end punctuation"],
	"Correct grammar and spelling": ["Correct grammar and spelling", "Some grammar or spelling issues", "Grammar or spelling issues"],
	"Good usage of punctuation": ["Good usage of punctuation","Some issues with organization","Issues with organization"],
	"Good introduction": ["Good introduction","Issues with the introduction"],
	"Avoiding overused words": ["Few repeated words","Some repeated words","Many repeated words" ],
	"Advanced word choice": ["Good word choice", "Some overused words", "Many repeated words"],
	"Including details from the text": ["Included details from the text","Included some details from the text","Did not include details from the text"],
	"Fully answering the question": ["Fully answered the question", "Partially answered the question", "Did not answer to the question"]
}



AnswerAnalysisDisplay.propTypes = StrictPropTypes({
	// gold records to display
	answerID: PropTypes.number.isRequired,
	delay: PropTypes.number.isRequired,
	showCoinTable: PropTypes.func,
	shouldCollapse: PropTypes.bool
});

module.exports = AnswerAnalysisDisplay;



// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerAnalysisDisplay.js